import React from 'react'

export const Goals = () => {
    return <>todo</>
}